/**
 * Checks if the current page is a Product Detail Page (PDP)
 * by verifying if the route matches the PDP pattern: /[locale]/shop/[urlKey]
 *
 * @param routePath - Optional route path to check, if not provided uses useRoute()
 * @returns true if the current route is a product detail page
 */
export function isProductDetailPage(routePath?: string): boolean {
  // PDP routes have the pattern: /[locale]/shop/[urlKey]
  const path = routePath ?? useRoute().path;
  const pathSegments = path.split('/').filter(Boolean);
  return pathSegments.length >= 2 && pathSegments[1] === 'shop';
}
